export const resourceMap = [
	{ resourceId: 3, title: 'Down Under', color: '#88B7B5' },
	{ resourceId: 1, title: 'Day', color: '#361134' },
	{ resourceId: 2, title: 'Night', color: '#6E675F' },
	{ resourceId: 4, title: 'Back Bar', color: '#6369D1' },
	{ resourceId: 5, title: 'Security', color: '#8c3636' },
];

export const styles = theme => ({
	h1: {
		color: '#0277bd',
		fontSize: '48px',
		fontWeight: 200,
		margin: 0,
	},
	icon: {
		fontSize: '48px',
		fontWeight: 200,
	},
	h1icon: {
		color: 'inherit',
		padding: '0 5px',
	},
});

const defaultShifts = [6, 6, 7, 8, 8, 12, 13, 13, 17, 18, 20, 20];
const defaultWeekendShifts = [6, 7, 11, 12, 17, 18, 18, 20];
const defaultHours = [10.5, 10.5, 10.5, 10.5, 10.5, 10.5, 10.5, 10.5, 12.5, 12.5, 10.5, 10.5];
const defaultWeekendHours = [10.5, 10.5, 10.5, 10.5, 12.5, 10.5, 12.5, 10.5];
